module.exports = __webpack_public_path__ + "img/three2Orange.9ab59dbd.jpg";